import React, { Component } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';

import SingleDatePickerFilter from './single-date-picker-filter';
import ResetFilterButton from './reset-filter-button';

export default class SingleDatePickerFilterContainer extends Component{
    state = {
        date: null,
    };

    // ----BEGIN REQUIRED METHODS FOR AGGRID----
    isFilterActive = () => this.state.date !== null;

    doesFilterPass = ( params ) => {
        const nodeDate = this.props.valueGetter( params.node );
        // the value `day` compares only the year, month, and day of each year
        return this.state.date.utc().isSame( moment( nodeDate ).utc(), 'day' );
    };

    getModel = () => {
        /**
         * Return an object with the key `values` as an array
         * The serverFilterHandler method in table-utils 
         * checks for values.length > 0 on filters
         * to see if there are filters or not
         */
        if( this.state.date ){
            return { values: [this.state.date] };
        }

        // Return an empty array if date is not selected or unselected
        return { values: [] };
    }

    setModel = ( model ) => {
        const dateExists = model ? model.value : null;
        this.setState( { date: dateExists }, this.props.filterChangedCallback() );
    }
    // ----END REQUIRED METHODS FOR AGGRID----

    onDateChanged = ( selectedDate ) => {
        const { filterChangedCallback } = this.props;

        if( selectedDate === this.state.date ){
            this.resetFilter();
        }
        else{
            this.setState( { date: selectedDate }, () => filterChangedCallback( ) );
        }

    }
    resetFilter = () => {
        const { filterChangedCallback } = this.props;

        this.setState( { date: null }, () => filterChangedCallback() );
    }

    render(){
        return (
            <>
                <SingleDatePickerFilter
                    dataAutomationId="single-date-picker-filter"
                    onDateChanged={this.onDateChanged}
                    date={this.state.date}
                    resetFilter={this.resetFilter}
                />
                <ResetFilterButton onClick={ this.resetFilter } noPadding />
            </>
        );
    }
}

SingleDatePickerFilterContainer.propTypes = {
    filterChangedCallback: PropTypes.func.isRequired,
    valueGetter: PropTypes.func.isRequired,
};
